import { render, staticRenderFns } from "./InvitationHeader.vue?vue&type=template&id=2e486e02&scoped=true&"
import script from "./InvitationHeader.vue?vue&type=script&lang=ts&"
export * from "./InvitationHeader.vue?vue&type=script&lang=ts&"
import style0 from "./InvitationHeader.vue?vue&type=style&index=0&id=2e486e02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e486e02",
  null
  
)

export default component.exports